/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfBilling } from '../../models/data-page-of-billing';

export interface BillingSearchprocedures$Params {
  code?: string | null;
  name?: string | null;
}

export function billingSearchprocedures(http: HttpClient, rootUrl: string, params?: BillingSearchprocedures$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
  const rb = new RequestBuilder(rootUrl, billingSearchprocedures.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfBilling>;
    })
  );
}

billingSearchprocedures.PATH = '/billing/searchprocedures';
